<template>
  <section ref="imagenRef" class="imagen-arco-wrapper">
    <div ref="arcoRef" class="arco">
      <img
        src="@/assets/RON05628.jpg"
        alt="Pareja elegante"
        class="imagen-arco"
      />
    </div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ImagenArcoElegante',
  setup() {
    const imagenRef = ref(null)
    const arcoRef = ref(null)

    onMounted(async () => {
      await nextTick()

      // 🔹 Estado inicial FUERTE (no se ve antes)
      gsap.set(arcoRef.value, {
        y: 140,
        scale: 0.82,
        opacity: 0,
        filter: 'blur(6px)'
      })

      gsap.fromTo(
        arcoRef.value,
        {},
        {
          scrollTrigger: {
            trigger: imagenRef.value,
            start: 'top 85%',        // 👈 entra CUANDO YA LO VES
            toggleActions: 'play none none none',
            once: true
          },
          y: 0,
          scale: 1,
          opacity: 1,
          filter: 'blur(0px)',
          duration: 1.6,
          ease: 'power3.out',
          delay: 0.25              // 👈 hero delay sutil
        }
      )

      ScrollTrigger.refresh()
    })

    return {
      imagenRef,
      arcoRef
    }
  }
}
</script>

<style scoped>
.imagen-arco-wrapper {
  background-color: #efe6dc;
  padding: 0px 4px;
  display: flex;
  justify-content: center;
}

/* CONTENEDOR EN FORMA DE ARCO */
.arco {
  width: 380px;
  height: 520px;
  background-color: white;
  border-radius: 200px 200px 0 0;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
}

/* IMAGEN */
.imagen-arco {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
